import { string } from 'yup'

export const filename = string().default('').required().meta({ hide: true, autoFill: true })
